<template>
	<div class="container-fluid">
		<!-- <h1>ProjectContainer [{{projectId}}]</h1> -->
		<error-404 v-if="initialized && notFound" heading="Project Not Found">
			Project [{{projectId}}] could not be found!
		</error-404>
		<div class="row">
			<div class="col-sm-5 col-md-5 col-lg-4 col-xl-4 mb-4">
				<project-navigation :breadcrumb="breadcrumb"></project-navigation>
			</div>
			
			<div class="col-sm-7 col-md-7 col-lg-8 col-xl-8 mb-4">
				
				<router-view v-if="initialized && !notFound" />
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import Error404 from '@/components/Error404';
import ProjectNavigation from "@/components/utilities/ProjectNavigation";
import { updateBreadcrumb } from '../../util';

export default {
	name: "project-view",
	props: [ 'nodeId', 'projectId' ],
	components: { Error404, ProjectNavigation },
	data() {
		return {
			initialized : false,
			notFound : false,
		};
	},
	watch:
	{
		'$route.path' : async function( newValue, oldValue )
		{
			this.initialized = false;
			await this.checkProject( );
		}
	},
	computed:
	{
		breadcrumb: function( )
		{
			return updateBreadcrumb( this.$route );
		},
	},
	methods: {
		...mapActions({
			readProject: "projects/read"
		}),
		async checkProject( nocache = false )
		{
			try {
				let result = await this.readProject( { nodeId : this.nodeId, projectId : this.projectId, nocache : nocache } );
				if( result )
				{
					console.log( "[ProjectContainer] Project '"+ this.projectId +"' found!" );
					this.notFound = false;
				}
				else
				{
					console.log( "[ProjectContainer] Could not find project '"+ this.projectId +"'" );
					this.notFound = true;
				}
			} catch( err ) {
				throw err;
			}
			this.initialized = true;
		}
	},
	async created( )
	{
		// First, check cache.
		if( this.$store.getters['projects/project']( this.nodeId, this.projectId ) )
		{
			this.notFound = false;
			this.initialized = true;
		}
		// Then initiate a project load in the background
		await this.checkProject( true );	
	},
};
</script>


// WEBPACK FOOTER //
// src/components/containers/ProjectContainer.vue